<template>
  <div id="adureg">
    <div class="zhuc">
      <!-- 进度 -->
      <div class="steps_div">
        <div class="zsxx">
          <div class="circular" :class="[  activeStep >= 1 ? 'eventBackground' : '' ]">1</div>
          <div class="words" :class="[ activeStep >= 1 ? 'eventColor' : '' ]">
            <p>信息填写</p>
            <p>填写观众信息及调查问卷</p>
          </div>
        </div>
        <div class="line1"></div>
        <div class="szzh">
          <div class="circular" :class="[ activeStep >= 2 ? 'eventBackground' : '' ]">2</div>
          <div class="words" :class="[ activeStep >= 2 ? 'eventColor' : '' ]">
            <p>设置账号</p>
            <p>设置展会登录账号与密码</p>
          </div>
        </div>
        <div class="line2"></div>
        <div class="zccg">
          <div class="words" :class="[ activeStep >= 3 ? 'eventColor' : '' ]">
            <p>注册成功</p>
            <p>观众完成注册</p>
          </div>
          <div class="circular" :class="[ activeStep >= 3 ? 'eventBackground' : '' ]">3</div>
        </div>
      </div>

      <!-- 第一步 -->
      <div class="register_1" v-show="activeStep === 1">
        <el-form
          class="register-form"
          ref="register1_Form"
          :model="form"
          label-width="0px"
          :rules="rules"
        >
          <el-form-item>
            <div class="lxr">
              <p>观众信息</p>
              <p>
                <span>*</span>为必填项
              </p>
            </div>
          </el-form-item>

          <el-form-item label="姓名：" label-width="190px" prop="name">
            <el-input v-model="form.name" placeholder="请填写姓名"></el-input>
          </el-form-item>

		  <el-form-item label="称谓：" label-width="190px" prop="sex" class="cw">
            <el-radio v-model="form.sex" label="0">先生</el-radio>
            <el-radio v-model="form.sex" label="1">女士</el-radio>
          </el-form-item>

          <el-form-item label="手机号码：" label-width="190px" prop="telephone">
            <el-input v-model="form.telephone" placeholder="请填写您的手机号"></el-input>
          </el-form-item>

          <el-form-item label="邮箱：" label-width="190px" prop="email">
            <el-input v-model="form.email" placeholder="请填写您的邮箱"></el-input>
          </el-form-item>
		  
		  <el-form-item label="省份：" label-width="190px" prop="province">
		    <el-select v-model="form.province" placeholder="请选择" @change="provinceChange">
		      <el-option
		        v-for="item in provinceList"
		        :key="item.value"
		        :label="item.label"
		        :value="item.value"
		      ></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="城市：" label-width="190px" prop="city">
		    <el-select v-model="form.city" placeholder="请选择" @change="cityChange">
		      <el-option
		        v-for="item in cityList"
		        :key="item.value"
		        :label="item.label"
		        :value="item.value"
		      ></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="地址：" label-width="190px"  prop="address">
		    <el-input v-model="form.address" placeholder="请填写您的地址"></el-input>
		  </el-form-item>

        <!--  <el-form-item label="学校：" label-width="190px" prop="school">
            <el-select v-model="form.school" placeholder="请选择">
              <el-option
                v-for="item in schoolList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="行业：" label-width="190px" prop="industry">
            <el-select v-model="form.industry" placeholder="请选择">
              <el-option
                v-for="item in industryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
		  
		  <el-form-item label="行业性质或学校类型：" label-width="190px"  prop="industryType">
		      <el-select v-model="form.industryType" placeholder="请选择"  @change="industryTypeChange" class="xxxz">
		        <el-option
		          v-for="item in industryTypeList"
		          :key="item.value"
		          :label="item.label"
		          :value="item.value"
		        ></el-option>
		      </el-select>
			  
			  <el-select v-model="form.industrySubtype" placeholder="请选择"  @change="industrySubtypeChange"  class="xxxz_2">
			    <el-option
			      v-for="item in industrySubtypeList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value"
			    ></el-option>
			  </el-select>
			  
			  <!-- <el-select v-model="form.industryGrandsontype" placeholder="请选择">
			    <el-option
			      v-for="item in industryGrandsontypeList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value"
			    ></el-option>
			  </el-select> -->
		
		 </el-form-item>

		 <el-form-item label="单位：" label-width="190px"   prop="company">
            <el-input v-model="form.company" placeholder="请填写您的单位"></el-input>
          </el-form-item>

          <el-form-item label="职务：" label-width="190px"   prop="job">
            <el-input v-model="form.job" placeholder="请填写您的职务"></el-input>
          </el-form-item>

          <el-form-item label="部门：" label-width="190px"   prop="department">
            <el-input v-model="form.department" placeholder="请填写您的部门"></el-input>
          </el-form-item>

          <el-form-item>
            <div class="lxr wjdc">
              <p>调查问卷</p>
              <p>
                <span>*</span>为必填项
              </p>
            </div>
          </el-form-item>

          <el-form-item label=" " label-width="80px" prop="problem1">
            <p class="p_txt">1.您是通过什么途径知道这个展会？可多选</p>
            <el-checkbox-group v-model="form.problem1" @change="checkBox1">
              <el-checkbox label="网络/官网"></el-checkbox>
              <el-checkbox label="展会邀请函电子邮件"></el-checkbox>
              <el-checkbox label="相关行业协会/学会"></el-checkbox>
              <el-checkbox label="网络/微信/微博平台"></el-checkbox>
              <el-checkbox label="展商或同行邀请"></el-checkbox>
              <el-checkbox label="其他">
                其他，请注明
                <el-input
                  v-model="form.cType_qit1"
                  :disabled="cType_qita1"
                  class="radio_input"
                  placeholder="备注"
                ></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label=" " label-width="80px" class="p_radio" prop="problem2">
            <p class="p_txt">2.请问您的身份？</p>
            <el-radio-group v-model="form.problem2">
              <el-radio :label="'企业'">企业</el-radio>
              <el-radio :label="'学校'">学校</el-radio>
              <el-radio :label="'媒体'">媒体</el-radio>
              <el-radio :label="'教育行政管理部门、协会、学会'">教育行政管理部门、协会、学会</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label=" " label-width="80px" class="p_radio" prop="problem3">
            <p class="p_txt">3.请问您的行业性质？</p>
            <el-radio-group v-model="form.problem3" @change="cTypeRadio">
              <el-radio :label="'经销商/代理商'">经销商/代理商</el-radio>
              <el-radio :label="'投资公司/招投标代理公司'">投资公司/招投标代理公司</el-radio>
              <el-radio :label="'集成商'">集成商</el-radio>
              <el-radio :label="'制造商'">制造商</el-radio>
              <el-radio :label="'教育培训及咨询机构'">教育培训及咨询机构</el-radio>
              <el-radio :label="'教育出版社/教育出版团'">教育出版社/教育出版团</el-radio>
              <el-radio :label="'科研机构'">科研机构</el-radio>
              <el-radio :label="'本科院校'">本科院校</el-radio>
              <el-radio :label="'高职高专'">高职高专</el-radio>
              <el-radio :label="'普教（含中专）'">普教（含中专）</el-radio>
              <el-radio :label="'学前教育'">学前教育</el-radio>
              <el-radio :label="'其他'">
                其他，请注明
                <el-input
                  v-model="form.cType_qit3"
                  :disabled="cType_qita3"
                  class="radio_input"
                  placeholder="备注"
                ></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label=" " label-width="80px" prop="problem4">
            <p class="p_txt">4.请问您关注哪类产品或服务？可多选</p>
            <el-checkbox-group v-model="form.problem4" @change="checkBox4">
              <el-checkbox label="实验室&科研仪器设备与技术类"></el-checkbox>
              <el-checkbox label="信息化&智慧育类"></el-checkbox>
              <el-checkbox label="平安校园&后勤类"></el-checkbox>
              <el-checkbox label="实训&健康类"></el-checkbox>
              <el-checkbox label="寻求集成商/分销商/代理商"></el-checkbox>
              <el-checkbox label="了解行业发展"></el-checkbox>
              <el-checkbox label="专业观众"></el-checkbox>
              <el-checkbox label="行业论坛"></el-checkbox>
              <el-checkbox label="其他">
                其他，请注明
                <el-input
                  v-model="form.cType_qit4"
                  :disabled="cType_qita4"
                  class="radio_input"
                  placeholder="备注"
                ></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-button class="next" @click="onNext(2)">下一步</el-button>
          <el-button class="reset">重置</el-button>
        </el-form>
      </div>

      <!-- 第二步 -->
      <div class="register_2" v-show="activeStep === 2">
        <el-form class="register-form" :model="form" ref="register2_Form" :rules="rules2">
          <el-form-item>
            <div class="lxr">
              <p>账号信息</p>
              <p>
                <span>*</span>为必填项
              </p>
            </div>
          </el-form-item>

          <el-form-item label="手机：" label-width="190px" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入手机号，可用于展会联络与密码找回等"></el-input>
          </el-form-item>

          <el-form-item label label-width="190px" style="position: relative;">
            <el-input v-model="form.code" placeholder="请输入短信验证码"></el-input>
            <el-button
              v-if="msgSend"
              type="text"
              style="position: absolute;right: 20px;color: #1879c0;margin-top: -40px;"
            >{{ msgSendTimeOut }} 秒后可重发</el-button>
            <el-button
              v-else
              type="text"
              style="position: absolute;right: 20px;color: #1879c0;margin-top: -40px;"
              @click="getCode"
            >发送验证码</el-button>
          </el-form-item>

          <el-form-item label="密码：" label-width="190px" prop="password">
            <el-input v-model="form.password" type="password" placeholder="设置6至16位数字或字母或数字+字母登录密码"></el-input>
          </el-form-item>

          <el-form-item label="确认密码：" label-width="190px" prop="confirmPassword">
            <el-input v-model="form.confirmPassword" type="password" placeholder="请再次输入登录密码"></el-input>
          </el-form-item>

          <el-form-item label="网站注册号：" label-width="190px" prop="regCode">
            <el-input v-model="form.regCode" placeholder="网站注册号通过微信扫描并关注下方公众号后获取"></el-input>
          </el-form-item>

          <el-form-item label label-width="190px">
            <div class="gzh_qrcode">
              <div class="qrcode_img">
                <img :src="require('../../assets/image/gzh_qrcode.jpg')" alt />
              </div>
              <div class="qrcode_text">
                <p>如您已关注&nbsp;"中国现代教育装备网"&nbsp;微信公众号，请在公众号内</p>
                <p>回复数字&nbsp;"1"&nbsp;，获取网站注册号</p>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <el-button class="next" @click="onNext(3)">下一步</el-button>
      </div>

      <!-- 第三步 -->
      <div class="register_3" v-show="activeStep === 3">
        <p>
          <img src="../../assets/image/success_.png" alt />
        </p>
        <p class="text_color">您已注册成功</p>
        <el-button class="back_home" @click="onNext(1)">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import area from "@/utils/area.js";
import industry from "@/utils/industry.js";

export default {
  name: "register",
  components: {},
  data() {
    //密码校验规则
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    //确认密码校验规则
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    //手机号校验规则
    let mobileValidata = (rule, value, callback) => {
      let testStr = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!testStr.test(value)) {
        callback(new Error("请输入正确的手机号码!"));
      } else {
        callback();
      }
    };

    // 邮箱校验规则
    let emailValidata = (rule, value, callback) => {
      let emailTest = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!emailTest.test(value)) {
        callback(new Error("请输入正确的邮箱!"));
      } else {
        callback();
      }
    };

    return {
      activeStep: 1, //当前步骤
      msgSendTimeOut: 59, //短信重发间隔
      msgSend: false, //短信是否已发送

      // 学校list
      schoolList: [
        {
          value: "高教",
          label: "高教",
        },
        {
          value: "普教",
          label: "普教",
        },
        {
          value: "幼教",
          label: "幼教",
        },
        {
          value: "职教",
          label: "职教",
        },
      ],
      // 行业list
      industryList: [
        {
          value: "生产商",
          label: "生产商",
        },
        {
          value: "经销商",
          label: "经销商",
        },
        {
          value: "集成商",
          label: "集成商",
        },
        {
          value: "品牌商",
          label: "品牌商",
        },
        {
          value: "代理商",
          label: "代理商",
        },
        {
          value: "采购商",
          label: "采购商",
        },
        {
          value: "出版商",
          label: "出版商",
        },
        {
          value: "教育机构",
          label: "教育机构",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],
      problem1List: [],
      problem4List: [],
      provinceList: [], // 省
      cityList: [], // 市
	  industryTypeList:[],
	  industrySubtypeList:[],
	  industryGrandsontypeList:[],

      cType_qita1: true,
      cType_qita3: true,
      cType_qita4: true,
      form: {
        name: "", // 姓名
        job: "", // 职位
        telephone: "", // 手机号
        email: "", // 邮箱
        school: "", // 学校
        industry: "", // 行业
        company: "", // 单位
        sex: "0",
        department: "", // 部门
        province: "", // 省
        city: "", // 市
        address: "", // 地址
		industryType: "",
		industrySubtype: "",
		industryGrandsontype: "",
        problem1: [],
        problem2: "",
        problem3: "",
        problem4: [],
        cType_qit1: "",
        cType_qit3: "",
        cType_qit4: "",
        // 第二步
        phone: "",
        code: "",
        password: "",
        confirmPassword: "",
        regCode: "",
      },
      //表单校验规则
      rules: {
        name: [{ required: true, message: "*为必填项", trigger: "blur" }], // validator 校验规则
        telephone: [
          {
            required: true,
            validator: mobileValidata,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            validator: emailValidata,
            trigger: "blur",
          },
        ],
        school: [{ required: true, message: "*为必填项", trigger: "change" }],
        industry: [{ required: true, message: "*为必填项", trigger: "change" }],
        company: [{ required: true, message: "*为必填项", trigger: "blur" }],
        sex: [{ required: true, message: "*为必填项", trigger: "blur" }],
        job: [{ required: true, message: "*为必填项", trigger: "blur" }],
        department: [{ required: true, message: "*为必填项", trigger: "blur" }],
        province: [{ required: true, message: "*为必填项", trigger: "change" }],
        city: [{ required: true, message: "*为必填项", trigger: "change" }],
		address: [{ required: true, message: "*为必填项", trigger: "change" }],
		industryType: [{ required: true, message: "*为必填项", trigger: "change" }],
        problem1: [
          {
            required: true,
            message: "*为必填项",
            trigger: "change",
          },
        ],
        problem2: [{ required: true, message: "*为必填项", trigger: "change" }],
        problem3: [{ required: true, message: "*为必填项", trigger: "change" }],
        problem4: [
          {
            required: true,
            message: "*为必填项",
            trigger: "change",
          },
        ],
      },
      rules2: {
        phone: [{ required: true, validator: mobileValidata, trigger: "blur" }],
        password: [
          {
            required: true,
            validator: validatePass,
            message: "*为必填项",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "*为必填项", trigger: "blur" }],
        regCode: [{ required: true, message: "*为必填项", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.provinceHandle();
	this.industryHandle();
  },
  methods: {
    // 返回首页
    backHome() {
      this.$router.push("/login");
    },

    // 省份处理
    provinceHandle() {
      let proArr = [];
      area.forEach((ele, index) => {
        proArr[index] = {
          label: ele.name,
          value: ele.name,
        };
      });
      this.provinceList = proArr;
    },

    // 行业性质单选
    cTypeRadio(val) {
      if (val === "其他") {
        this.cType_qita3 = false;
      } else {
        this.cType_qita3 = true;
      }
    },

    // 年份选择
    cYearDate(val) {},
    // 员工规模
    cPeoplesSelect(val) {},
    // 参展状态一级select
    cExhibitionSelect(val) {
      let childSelect = this.statusList.filter((res) => {
        return res.sta === val;
      });
      let arr = [];
      childSelect[0].children.forEach((el, index) => {
        arr[index] = {
          label: el,
          value: el,
        };
      });
      this.optionsChild = arr;
    },
    // 参展状态二级select
    cExhibitionChildSelect(val) {
      this.form.cExhibition = val;
    },

    // 省份
    provinceChange(val) {
      let cityArr = area.filter((res) => {
        return res.name === val;
      });
      let arr = [];
      cityArr[0].cities.forEach((ele, index) => {
        arr[index] = {
          label: ele.name,
          value: ele.name,
        };
      });
      this.cityList = arr;
    },
    // 城市
    cityChange(val) {},
	
	
	//行业
	industryHandle(){
		let industryTypeArr = [];
		industry.forEach((ele, index) => {
		  industryTypeArr[index] = {
		    label: ele.name,
		    value: ele.name,
		  };
		});
		this.industryTypeList = industryTypeArr;
		this.form.industryType = this.industryTypeList[0].label;
		this.industryTypeChange(this.industryTypeList[0].label);
	},
	
	//一级----industry.filter一级改变获取二级值
	industryTypeChange(val) {
	  let industrySubtypeArr = industry.filter((res) => {
	    return res.name === val;
	  });
	  
	  let arr = [];
	  industrySubtypeArr[0].level11s.forEach((ele, index) => {
	    arr[index] = {
	      label: ele.name,
	      value: ele.name,
	    };
	  });
	  this.industrySubtypeList = arr;
	  this.form.industrySubtype = arr[0].label;
	  
	  this.industrySubtypeChange(arr[0].label);
	},
	
	//二级
	industrySubtypeChange(val) {
	  //获取第三级的值	
	  let industryGrandsontypeArr = [];
	  industry.forEach((res, index) => {
		res.level11s.forEach((ele, index) => {
		   if(ele.name === val){
			  industryGrandsontypeArr = ele.level111s;
		   }	
		});
	  });
	  
	  let arr = [];
	  if(industryGrandsontypeArr.length>0){
		  industryGrandsontypeArr.forEach((ele, index) => {
		    arr[index] = {
		      label: ele.name,
		      value: ele.name,
		    };
		  });
		  this.form.industryGrandsontype = arr[0].label;
	  }else{
		  this.form.industryGrandsontype = '';
	  }
	   this.industryGrandsontypeList = arr;
	},
	

    checkBox1(val) {
      let haveQT = val.filter((ele) => {
        return ele === "其他";
      });
      if (haveQT.length > 0) {
        this.cType_qita1 = false;
      } else {
        this.cType_qita1 = true;
      }
    },
    checkBox4(val) {
      let haveQT = val.filter((ele) => {
        return ele === "其他";
      });
      if (haveQT.length > 0) {
        this.cType_qita4 = false;
      } else {
        this.cType_qita4 = true;
      }
    },

    //获取短信验证码
    getCode() {
      let me = this;

      if (!me.form.phone) {
        me.$message.error("请输入手机号码");
        return false;
      }

      let i = setInterval(function () {
        me.msgSendTimeOut -= 1;
        if (me.msgSendTimeOut <= 0) {
          me.msgSend = false;
          me.msgSendTimeOut = 59;
          clearInterval(i);
        }
      }, 1000);
      this.$http({
        url: "viewer/MsgCode",
        method: "post",
        params: {
          phone: this.form.phone,
          type: 1,
        },
      })
        .then((response) => {
          let { code, msg } = response.data;
          if (code === 0) {
            this.$message("验证码已发送至手机:" + this.form.phone);
            me.msgSend = true;
            this.form.codeId = response.data.codeId;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => console.log(error));
    },

    // 下一步
    onNext(num) {
      // 第一次点击下一步
      if (num === 2) {
        this.$refs["register1_Form"].validate((valid) => {
          if (valid) {
            this.form.problem1 = JSON.stringify({
              subset: JSON.stringify(this.form.problem1),
              remarks: this.form.cType_qit1 || "",
            });
            this.form.problem4 = JSON.stringify({
              subset: JSON.stringify(this.form.problem4),
              remarks: this.form.cType_qit4 || "",
            });
            this.activeStep = 2;
          } else {
            this.$message.error("请将带 * 的所有项填写完整！");
            this.activeStep = 1;
            return false;
          }
        });
        // this.activeStep = 2;
      } else if (num === 3) {
        // 第二次点击下一步
        this.$refs["register2_Form"].validate((valid) => {
          if (valid) {
            this.$http({
              url: "viewer/register",
              method: "post",
              data: this.$http.adornData({
                name: this.form.name, // 姓名
                telephone: this.form.telephone,
                email: this.form.email, // 邮箱
                job: this.form.job, // 职位
                school: this.form.school,
                industry: this.form.industry, // 行业
                company: this.form.company, // 单位
                sex: this.form.sex,
                department: this.form.department, // 部门
                province: this.form.province, // 省份
                city: this.form.city, // 市
                address: this.form.address, // 地址
				
			    industryType: this.form.industryType,
			    industrySubtype: this.form.industrySubtype,
			    industryGrandsontype: this.form.industryGrandsontype,
			  
                problem1: this.form.problem1,
                problem2: this.form.problem2,
                problem3: this.form.problem3,
                problem4: this.form.problem4,

                phone: this.form.phone, // 注册手机号
                password: this.form.password, // 密码
                code: this.form.code, // 手机验证码
                regCode: this.form.regCode, // 公众号验证码
              }),
            }).then(({ data }) => {
              let { code, msg } = data;
              if (code === 0) {
                this.activeStep = 3;
              } else {
                this.activeStep = 2;
                this.$message.error(msg);
              }
            });
          } else {
            this.$message.error("请将带 * 的所有项填写完整！");
            this.activeStep = 2;
            return false;
          }
        });
      } else {
        this.$emit("setRegs");
      }
    },
  },
};
</script>
<style lang="scss">
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #143372 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #143372 !important;
  border-color: #143372 !important;
}
.el-select-dropdown__item.selected {
  color: #143372 !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #143372 !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #ffffff !important;
}
.el-tag.el-tag--info .el-tag__close {
  display: none !important;
}
#adureg {
  .zhuc {
    width: 1200px;
    margin: 0 auto;
  }
  .register-form {
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before {
      margin-right: 19px;
    }

    .el-form-item__error {
      // display: none;
    }

    .el-form-item__label {
      padding: 0 12px 0 0;
    }
    .el-form-item {
      margin: 0 0 20px 0;
    }

    .el-input__inner {
      height: 40px;
      line-height: 40px;
    }

    .el-upload-list__item {
      width: 420px;
      height: 30px;
      line-height: 30px;
      background-color: #f0f0f0;
      font-size: 14px;
    }
    .el-upload-list__item-name {
      padding-left: 16px;
      color: #1879c0;
    }
    .el-upload-list__item .el-icon-close {
      color: #000000;
      top: 8px;
    }
    .el-icon-document:before {
      // content: "";
    }
    .rihtDpi {
      float: right;
      margin: 121px 510px 0 0;
      color: #999999;
    }
    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0 21.5px;
    }
    .el-checkbox {
      display: block;
      color: #333333;
      .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #143372;
      }
    }
    .el-radio {
      width: 95px;
    }
    .el-radio__inner {
      &:hover {
        border-color: #143372;
      }
    }
    .el-radio__input .el-radio__inner {
      width: 20px;
      height: 20px;
    }
    .cw {
      .el-radio {
        display: inline;
      }
    }

    .el-radio__input.is-checked .el-radio__inner {
      width: 20px;
      height: 20px;
      background-color: #ffffff;
      border: 2px solid #dcdfe6;
      border-color: #143372;
    }
    .el-radio__inner::after {
      width: 12px;
      height: 12px;
      background-color: #143372;
    }
    .p_radio {
      .el-radio__input.is-checked .el-radio__inner {
        width: 16px;
        height: 16px;
        background-color: #ffffff;
        border: 2px solid #dcdfe6;
        border-color: #143372;
      }
      .el-radio__inner::after {
        width: 6px;
        height: 6px;
        background-color: #143372;
      }
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #333333;
    }
    .el-radio__label {
      color: #333333;
    }
    .radio_input {
      margin-left: 41px;
      .el-input__inner {
        height: 42px;
        line-height: 42px;
      }
    }
    .gsjj {
      .el-textarea__inner {
        height: 300px;
      }
    }
    .cqr {
      .el-form-item__label {
        text-align: left;
      }
    }
    .clnf {
      .el-input__prefix {
        left: 83px;
        .el-icon-date:before {
          content: "\e6df";
        }
      }
      .el-input__inner {
        padding-left: 15px;
      }
    }
    .el-form-item.is-success .el-input__inner {
      border-color: #e5e5e5;
    }
    .el-input__suffix {
      // display: none;
    }
  }
}
.select_qita {
  .el-input__inner {
    height: 30px;
    line-height: 30px;
    margin-top: 7.5px;
    border-radius: 0;
  }
}

.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader {
  line-height: 12px;
}
.avatar-uploader .el-upload:hover {
  // border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 14px;
  color: #ffffff;
  width: 150px;
  height: 150px;
  line-height: 150px !important;
  text-align: center;
  background-color: #7f7f7f;
}
.el-icon-plus:before {
  content: "上传高清图" !important;
}
.qrcode {
  .el-icon-plus:before {
    content: "重新上传" !important;
  }
}
.avatar_qrcode {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
<style scoped lang="scss">
#adureg {
  width: 100%;
  margin: 0 auto;
}
.steps_div {
  width: 996px;
  height: 58px;
  margin: 100px auto 156px;
  position: relative;
  .zsxx,
  .szzh,
  .zccg {
    width: 220px;
    .circular {
      width: 52px;
      height: 52px;
      border: 3px solid #bbbbbb;
      color: #bbbbbb;
      border-radius: 50%;
      font-size: 15px;
      text-align: center;
      line-height: 52px;
      float: left;
      margin-right: 7px;
    }
    .words {
      color: #999999;
      float: right;
      margin-top: 10px;
      p:first-child {
        font-size: 18px;
        margin-bottom: 5px;
      }
      p:last-child {
        font-size: 14px;
      }
    }
  }
  .zsxx {
    float: left;
  }
  .szzh {
    float: left;
    width: 219px;
    margin-left: 212px;
  }
  .zccg {
    float: right;
    .circular {
      float: right;
    }
  }
  .line1,
  .line2 {
    width: 236px;
    height: 1px;
    background-color: #e5e5e5;
    position: absolute;
  }
  .line1 {
    left: 164px;
    top: 50%;
    margin-top: -0.5px;
  }
  .line2 {
    right: 175px;
    top: 50%;
    margin-top: -0.5px;
  }

  // 要添加的类名
  .eventBackground {
    background-color: #143372 !important;
    border-color: #143372 !important;
    color: #ffffff !important;
  }
  .eventColor {
    color: #143372 !important;
  }
}
.register_1 {
  width: 955px;
  height: 2625px;
  margin: 0 auto;
  .lxr,
  .qy {
    text-align: center;
    height: 47px;
    margin-bottom: 50px;
  }
  .lxr {
    p:first-child {
      height: 24px;
      line-height: 24px;
      margin-bottom: 9px;
      font-size: 24px;
      color: #333333;
    }
    p:last-child {
      height: 14px;
      line-height: 14px;
      color: #999999;
      font-size: 14px;
      span {
        color: red;
        line-height: 16px;
        margin-right: 5px;
      }
    }
  }
  .wjdc {
    margin-top: 29px;
  }
  .qy {
    margin-top: 30px;
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    color: #333333;
  }

  .register-form {
    .upload-demo {
      .el-button--default {
        width: 150px;
        height: 42px;
        background-color: #143372;
        color: #ffffff;
      }
      .el-upload__tip {
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        color: #999999;
      }
    }
    .el-radio {
      display: block;
      line-height: 3;
    }
    .radio_input {
      width: 512px;
      height: 42px;
      .el-input__inner {
        height: 42px !important;
      }
    }
    .zczb {
      width: 512px;
      margin-right: 24px;
    }
    .clnf {
      width: 110px;
      margin-right: 21px;
    }
    .gsjj {
      width: 624px;
      height: 300px;
    }
    .posi {
      position: relative;
      .desc {
        position: absolute;
        right: 210px;
        bottom: -5px;
        font-size: 14px;
        color: #bbbbbb;
      }
    }
    .czzt {
      width: 290px;
      margin-right: 30px;
    }
    .czzt_2 {
      width: 213px;
    }
    .yggm_type {
      width: 237px;
      margin-right: 30px;
    }
    .yggm_ly {
      width: 545px;
    }
  }
}
.register_1,
.register_2 {
  .el-input {
    width: 624px;
    height: 40px;
    .el-input__inner {
      height: 40px;
    }
  }
  .next,
  .reset {
    margin: 70px 0 0 190px;
    width: 220px;
    height: 54px;
    font-size: 18px;
  }
  .next {
    background-color: #143372;
    color: #ffffff;
  }
  .reset {
    color: #143372;
    border-color: #143372;
    margin-left: 14px;
    &:hover,
    &:focus {
      background-color: #ffffff;
    }
  }
}
.register_2 {
  width: 765px;
  // height: 3219px;
  margin: 0 auto;
  .lxr,
  .qy {
    text-align: center;
    height: 47px;
    margin-bottom: 50px;
  }
  .lxr {
    p:first-child {
      height: 24px;
      line-height: 24px;
      margin-bottom: 9px;
      font-size: 24px;
      color: #333333;
    }
    p:last-child {
      height: 14px;
      line-height: 14px;
      color: #999999;
      font-size: 14px;
      span {
        color: red;
        line-height: 16px;
        margin-right: 5px;
      }
    }
  }
  .qy {
    margin-top: 30px;
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    color: #333333;
  }
  .gzh_qrcode {
    width: 603px;
    height: 635px;
    border: 1px dashed #e4e4e4;
    text-align: center;
    color: #bbbbbb;
    font-size: 17px;
    margin-top: 20px;
    .qrcode_img {
      margin: 35px 0 56px 0;
    }
    .qrcode_text {
      p {
        line-height: 17px;
        line-height: 37px;
      }
    }
  }
}
.register_3 {
  width: 641px;
  height: 311px;
  margin: 50px auto 0;
  text-align: center;
  p {
    color: #999999;
    font-size: 14px;
  }
  .text_color {
    font-size: 24px;
    color: #50ad10;
    margin: 40px 0 28px 0;
  }
  .phone {
    margin-top: 28px;
  }
  .back_home {
    width: 220px;
    height: 54px;
    margin-top: 79px;
    background-color: #143372;
    font-size: 18px;
    color: #ffffff;
  }
}

.xxxz {
      width: 250px;
      margin-right: 30px;
    }
.xxxz_2 {
   margin-right: 30px;
}
</style>
